import React from "react";

const PricingTick = ({ className, height, width }) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 1080 1080"
      className={className}
    >
      <path
        className="a"
        d="M539.4011,1011.8362c258.3711,6.0834,476.8427-210.0593,475.5936-474.4853-1.27-268.9117-212.7651-475.09-476.626-474.3557C271.2017,63.7392,63.9248,275.82,64.2837,539.952,64.6377,800.504,281.06,1017.6643,539.4011,1011.8362Z"
      />
      <path
        className="a"
        d="M539.4011,1011.8362C281.06,1017.6643,64.6377,800.504,64.2837,539.952,63.9248,275.82,271.2017,63.7392,538.3687,62.9952c263.8609-.7348,475.3558,205.444,476.626,474.3557C1016.2438,801.7769,797.7722,1017.92,539.4011,1011.8362Z"
      />
      <path
        className="b fill-white"
        d="M403.775,752.2665q139.4274-139.564,278.8116-279.1749,19.6948-19.7282,39.3568-39.4923c30.41-30.5425,61.8561-62.1255,93.0222-92.963,3.8732-3.8328,5.7979-6.9231,5.7205-9.186-.0718-2.0881-1.8655-4.6625-5.3322-7.6521-5.6977-4.9136-10.9-10.371-15.93-15.6485-2.4018-2.52-4.8857-5.1254-7.3593-7.6007-5.18-5.1841-10.5345-10.5442-12.2234-10.5448-1.698,0-7.0735,5.3675-12.2724,10.5584C643.0077,424.9223,385.0589,685.4871,376.49,696.009l-3.7593,5.5406-4.9814-4.6921c-3.0727-2.8962-5.6283-5.2821-7.8445-7.35-4.0008-3.7354-6.8912-6.4345-9.7487-9.2532q-11.5906-11.4371-23.2054-22.849c-23.4981-23.112-47.7957-47.01-71.3394-70.8953A22.7651,22.7651,0,0,0,239.7573,580h-.0854c-7.7375,0-15.451,3.7913-22.93,11.269-8.2465,8.2477-10.18,16.6787-10.35,22.3-.222,7.3536,2.3791,12.6391,4.6739,14.9293,18.5293,18.4963,37.3,37.3638,55.4535,55.6106,25.8419,25.9752,52.563,52.8341,79.021,79.0587,13.1869,13.0684,31.3165,13.2529,46.19.476C395.9317,760.0347,400.0019,756.043,403.775,752.2665Z"
      />
    </svg>
  );
};

export default PricingTick;



// WEBPACK FOOTER //
// ./resources/assets/js/app/Icons/PricingTick.icon.js